export const offices = [
  {
    title: 'Headquarters',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland-v2.svg',
        country: 'Poland',
        city: 'Warsaw',
      },
    ],
  },
  {
    title: 'Development centers',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland-v2.svg',
        country: 'Poland',
        mobileCountry: 'PL',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Lithuania.svg',
        country: 'Lithuania',
        mobileCountry: 'LT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-states-of-america-v2.svg',
        country: 'USA',
        mobileCountry: 'US',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Germany.svg',
        country: 'Germany',
        mobileCountry: 'DE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/kazakhstan.svg',
        country: 'Kazakhstan',
        mobileCountry: 'KZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/azerbaijan.svg',
        country: 'Azerbaijan',
        mobileCountry: 'AZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Georgia-v2.svg',
        country: 'Georgia',
        mobileCountry: 'GE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Cyprus.svg',
        country: 'Cyprus',
        mobileCountry: 'CY',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/UAE-v2.svg',
        country: 'UAE',
        mobileCountry: 'AE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/india-v2.svg',
        country: 'India',
        mobileCountry: 'IN',
      },
    ],
  },
  {
    title: 'Representative offices',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-kingdom-v2.svg',
        country: 'United Kingdom',
        mobileCountry: 'GB',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Germany.svg',
        country: 'Germany',
        mobileCountry: 'DE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/kazakhstan.svg',
        country: 'Kazakhstan',
        mobileCountry: 'KZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Saudi_Arabia.svg',
        country: 'Saudi Arabia',
        mobileCountry: 'SA',
      },
      {
        flag: 'https://content.andersenlab.com/common-data/flags/oman/1760026800.svg',
        country: 'Oman',
        mobileCountry: 'OM',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/hungary.svg',
        country: 'Hungary',
        mobileCountry: 'HU',
      },
    ],
  },
];
